import * as Dialog from '@radix-ui/react-dialog';
import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const ModalContent = styled(Dialog.Content).attrs<{
    $width: number;
    $scrollable?: boolean;
}>((props) => ({
    style: {
        maxWidth: `${props.$width}px`,
        width: `${props.$width}px`,
    },
}))<{
    $width: number;
    $scrollable?: boolean;
}>`
    text-align: left;
    vertical-align: middle;
    position: relative;
    padding: 0;
    box-shadow: ${theme.shadows.extraLarge};
    border-radius: 8px;
    max-height: 80vh;
    background-color: white;
    overflow: ${(props) => (props.$scrollable ? 'auto' : 'visible')};
    z-index: ${theme.zIndex.modal};
`;
